import { ChangeDetectionStrategy, Component, ContentChild, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { WorkspaceFileUserStatus } from '@common/workspace/enums/workspace-file-user-status.enum';
import { WorkspaceFileUser } from '@common/workspace/models/workspace-file-user.model';
import { WorkspaceFile } from '@common/workspace/models/workspace-file.model';
import { CurrentService } from '@portal-core/current/services/current.service';
import { WorkspaceFilesUserStatusListCurrentUserWarningDirective } from '@portal-core/project-files/workspace/directives/workspace-files-user-status-list-current-user-warning/workspace-files-user-status-list-current-user-warning.directive';
import { WorkspaceFilesUserStatusListWarningDirective } from '@portal-core/project-files/workspace/directives/workspace-files-user-status-list-warning/workspace-files-user-status-list-warning.directive';
import { WorkspaceFileService } from '@portal-core/project-files/workspace/services/workspace-file.service';

@Component({
  selector: 'mc-workspace-files-user-status-list',
  templateUrl: './workspace-files-user-status-list.component.html',
  styleUrls: ['./workspace-files-user-status-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkspaceFilesUserStatusListComponent {
  @Input() licenseId: number;
  @Input() workspaceFiles: WorkspaceFile[];
  @Input() workspaceFileUserStatus?: WorkspaceFileUserStatus;

  @ContentChild(WorkspaceFilesUserStatusListCurrentUserWarningDirective) currentUserWarningDirective: WorkspaceFilesUserStatusListCurrentUserWarningDirective;
  @ContentChild(WorkspaceFilesUserStatusListWarningDirective) warningDirective: WorkspaceFilesUserStatusListWarningDirective;

  WorkspaceFileUserStatus: typeof WorkspaceFileUserStatus = WorkspaceFileUserStatus;

  currentUserHasInProgressFiles: boolean;
  currentUserId: string;
  workspaceFileUsers: WorkspaceFileUser[];

  constructor(private currentService: CurrentService, private workspaceFileService: WorkspaceFileService) {
    this.currentUserId = this.currentService.getUserId();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.workspaceFiles || changes.workspaceFileUserStatus) {
      if (this.workspaceFiles?.length > 0) {
        this.currentUserHasInProgressFiles = this.workspaceFiles.some(workspaceFile => {
          return workspaceFile.userStatuses?.some(workspaceFileUser => {
            return workspaceFileUser.userId === this.currentUserId && (!this.workspaceFileUserStatus || workspaceFileUser.status === this.workspaceFileUserStatus);
          });
        });
        this.workspaceFileUsers = this.workspaceFileService.getUniqueWorkspaceFileUsers(this.workspaceFiles, this.currentUserId, this.workspaceFileUserStatus);
      } else {
        this.currentUserHasInProgressFiles = false;
        this.workspaceFileUsers = null;
      }
    }
  }
}
